// extracted by mini-css-extract-plugin
export default {"cta":"CTA_cta__dUwW4","btn":"CTA_btn__QxqRO","btnRow":"CTA_btnRow__k5niA","main":"CTA_main__6cP9t","why":"CTA_why__jwe4c"};